import { render } from "./NoteText.vue?vue&type=template&id=1d2bf762&scoped=true"
import script from "./NoteText.vue?vue&type=script&lang=js"
export * from "./NoteText.vue?vue&type=script&lang=js"

import "./NoteText.vue?vue&type=style&index=0&id=1d2bf762&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2bf762"]])

export default __exports__